import type { MockSectionCustomerInput } from './mockSectionData.util';
import { mockSectionData } from './mockSectionData.util';
import type { ReportSectionFieldSources } from './reportFieldSource.util';
import { isWarehouseWhoWereReachingSnapshot } from './whoWereReachingSnapshotDetect.util';

const WAREHOUSE_FIELD_SOURCES: ReportSectionFieldSources = {
  membersSeenByPcp: 'warehouse',
  pctEngagedConnectedPcp: 'warehouse',
  pctDisconnectedNowInPcp: 'warehouse',
  noPreEngPcpVisit: 'warehouse',
  eligibleCostPcpConnected: 'warehouse',
  pcpCareTrend: 'warehouse',
  insights: 'mock',
};

const MOCK_FIELD_SOURCES: ReportSectionFieldSources = {
  membersSeenByPcp: 'mock',
  pctEngagedConnectedPcp: 'mock',
  pctDisconnectedNowInPcp: 'mock',
  noPreEngPcpVisit: 'mock',
  eligibleCostPcpConnected: 'mock',
  pcpCareTrend: 'mock',
  insights: 'mock',
};

/**
 * Normalizes connections-primary-care snapshots with `fieldSources` for mock framing.
 * @param snapshot - Stored or live snapshot JSON.
 * @param customer - Customer context for mock fallback fields.
 * @param reportingPeriod - Report period label.
 * @returns Snapshot with `fieldSources` metadata for the Care Portal UI.
 */
export const normalizeConnectionsPrimaryCareSnapshot = (
  snapshot: Record<string, unknown>,
  customer: MockSectionCustomerInput,
  reportingPeriod: string,
): Record<string, unknown> => {
  const mockBase = mockSectionData(
    'connections-primary-care',
    customer,
    reportingPeriod,
  );
  const isWarehouse = isWarehouseWhoWereReachingSnapshot(snapshot);

  return {
    ...mockBase,
    ...snapshot,
    fieldSources: isWarehouse ? WAREHOUSE_FIELD_SOURCES : MOCK_FIELD_SOURCES,
    snapshotSource: isWarehouse ? snapshot.snapshotSource : undefined,
  };
};
